// extracted by extract-css-chunks-webpack-plugin
module.exports = {"history":"history_ePxXs","history_wrap":"history_wrap_tQMbb","swiper":"swiper_kZhm-"};